<template>
  <div>
    <div v-for="(note, index) in localNotes" :key="index" class="mb-3">
      <div class="border border-2 p-3 rounded-3 shadow-sm">

        <div class="w-100 d-flex flex-row align-items-start">
          <div class="row g-2 w-100">
            <div class="form-group col-md-8">
              <label for="standardTaxRate" class="form-label"><span data-bs-toggle="tooltip"
                                                                    :data-bs-title="$t('tooltips.noteContent')"
                                                                    class="badge ehw-green me-2">BT-22</span>{{
                  $t('form.noteContent')
                }}</label>
              <textarea
                  id="noteContent"
                  v-model="note.content"
                  @blur="emitUpdate"
                  class="form-control"
                  required
              />
            </div>
            <div class="form-group col-md-4">
              <SearchableDropdown input-id="noteSubjectCode" :label="$t('form.noteSubjectCode')"
                                  @update:modelValue="val => { note.subjectCode = val; emitUpdate(); }"
                                  :model-value="note.subjectCode" :options="masterDataStore.subjectCodes"
                                  bt-number="BT-21"
                                  :bt-tooltip="$t('tooltips.noteSubjectCode')"

              />
            </div>
          </div>
          <button
              @click.prevent="removeNote(index)"
              type="button"
              class="btn btn-danger btn-sm ms-2 py-2"
              style="margin-top: 32px"
          >
            {{ $t('ui.remove') }}
          </button>
        </div>
      </div>
    </div>
    <button @click.prevent="addNote" type="button" class="btn btn-secondary">
      {{ $t('ui.addNote') }}
    </button>
  </div>
</template>

<script>
import Note from '../../models/Note';
import SearchableDropdown from "@/components/Shared/SearchableDropdown.vue";
import {useMasterDataStore} from "@/stores/masterDataStore";

export default {
  components: {SearchableDropdown},
  props: {
    notes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localNotes: this.notes.map(note => note instanceof Note ? note : new Note(note)),
      masterDataStore: useMasterDataStore()
    };
  },
  methods: {
    emitUpdate() {
      this.$emit('update-notes', this.localNotes);
    },
    addNote() {
      this.localNotes.push(new Note({}));
      this.emitUpdate();
    },
    removeNote(index) {
      this.localNotes.splice(index, 1);
      this.emitUpdate();
    }
  },
  watch: {
    notes: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.localNotes = newVal.map(note => note instanceof Note ? note : new Note(note));
        console.log("Notes prop updated:", this.localNotes);
      }
    }
  }
};
</script>
